import { render, staticRenderFns } from "./ArticleEditDialog.vue?vue&type=template&id=425490f3&"
import script from "./ArticleEditDialog.vue?vue&type=script&lang=js&"
export * from "./ArticleEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./ArticleEditDialog.vue?vue&type=style&index=0&id=425490f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports